<script>

import Button from 'primevue/button';

export default{
    props: ['label', 'disabled'],
    components: { Button },
    data(){
        return{
            winWidth: window.innerWidth
        }
    },
    mounted(){
        window.addEventListener('resize', () => {
            this.winWidth = window.innerWidth;
        });
    }
};

</script>

<template>
    <Button :disabled="disabled || false" :label="winWidth < 800 ? null : label" v-tooltip="label"/>
</template>